import { LoadingLayoutWrapper } from 'components';
import { FormFooter } from 'modules/settings/common/components';
import { SettingsView } from 'modules/settings/common/views';

import {
  TimezoneSettings,
  TimezoneSettingsProps,
} from '../components/TimezoneSettings';
import {
  TimezoneFormProps,
  TimezoneSettingsForm,
} from '../components/TimezoneSettingsForm/TimezoneSettingsForm';

export interface TimezoneSettingsViewProps
  extends TimezoneFormProps,
    TimezoneSettingsProps {
  loading?: boolean;
  submitLoading?: boolean;
}

export const TimezoneSettingsView = ({
  onSubmit,
  timezones,
  loading,
  submitLoading,
  initialValues,
}: TimezoneSettingsViewProps) => (
  <SettingsView tabValue="timezone">
    <LoadingLayoutWrapper loading={loading}>
      <TimezoneSettingsForm initialValues={initialValues} onSubmit={onSubmit}>
        <TimezoneSettings timezones={timezones} />
        <FormFooter submitLoading={submitLoading} />
      </TimezoneSettingsForm>
    </LoadingLayoutWrapper>
  </SettingsView>
);
